import { useWatch, useFormContext } from "react-hook-form";

// Note: this doesn't trigger validation of the form. `trigger` needs to
// be called separately to produce the error state this hook reports on.

export const useSectionsValid = (
  checkTouched?: boolean,
  checkSection4?: boolean
): {
  section1: boolean;
  section2: boolean;
  section3: boolean;
  section2a: boolean;
  section2b: boolean;
  section2c: boolean;
  section2d: boolean;
  section4: boolean;
  all: boolean;
} => {
  const { formState } = useFormContext();

  const formData = {
    section1: {
      touched: useWatch({ name: "info.section1-touched" }),
    },
    section2: {
      touched: useWatch({ name: "info.section2-touched" }),
    },
    section3: {
      touched: useWatch({ name: "info.section3-touched" }),
    },
    section4Alt: {
      touched: false,
    },
    section2a: {
      show: useWatch({ name: "info.section2a-show" }),
      touched: useWatch({ name: "info.section2a-touched" }),
    },
    section2b: {
      show: useWatch({ name: "info.section2b-show" }),
      touched: useWatch({ name: "info.section2b-touched" }),
    },
    section2c: {
      show: useWatch({ name: "info.section2c-show" }),
      touched: useWatch({ name: "info.section2c-touched" }),
    },
    section2d: {
      show: useWatch({ name: "info.section2d-show" }),
      touched: useWatch({ name: "info.section2d-touched" }),
    },
    section4: {
      touched: useWatch({ name: "info.section4-touched" }),
    },
  };

  const sections = {
    section1:
      (checkTouched ? !!formData.section1.touched : true) &&
      !formState.errors.section1,
    section2:
      (checkTouched ? !!formData.section2.touched : true) &&
      !formState.errors.section2,
    section3:
      (checkTouched ? !!formData.section3.touched : true) &&
      !formState.errors.section3,
    section4Alt: true,
    section4:
      !checkSection4 ||
      ((checkTouched ? !!formData.section4.touched : true) &&
        !formState.errors.section4),
    section2a: false,
    section2b: false,
    section2c: false,
    section2d: false,
  };

  const subSections = ["a", "b", "c", "d"];
  subSections.forEach((subSection) => {
    const key = `section2${subSection}`;
    sections[key] =
      !formData[key].show ||
      !!(
        formData[key].show &&
        (checkTouched ? formData[key].touched : true) &&
        !formState.errors[key]
      );
  });

  return {
    ...sections,
    all: !Object.values(sections).some((valid) => !valid),
  };
};
